<template>
  <component
      :is="componentIs"
      class="card-promotion-small"
      :href="href"
      :targetBlank="item.targetBlank"
      :linkNofollow="item.linkNofollow"
      v-if="item && Object.keys(item).length > 0 && ($config.editMode || isPromotionInDateRange)"
      :class="classes"
      :id="`id-${item.uuid}`"
  >
    <div v-if="$config.editMode && !isPromotionInDateRange"
         class="edit-alert-msg">
      Attention: promotion is expired or future or it was removed
    </div>
    <slot name="select"></slot>
    <div class="card-promotion-small__img">
      <pg-image
          v-if="isSmall"
          :lazy-src="item.imageMobile | mgnlMedia('url')"
          :alt="item.imageMobile.media_name"
      />
      <picture v-else>
        <source
            media="(min-width:0) and (max-width:640px)"
            :srcset="item.imageMobile | mgnlMedia('url')"
            v-if="item.imageMobile"
        />
        <source
            media="(min-width:641px)"
            :srcset="item.imageMobile | mgnlMedia('url')"
        />
        <pg-image
            :lazy-src="item.imageMobile | mgnlMedia('url')"
            :alt="item.imageMobile.media_name"
        />
      </picture>
    </div>
    <div class="card-promotion-small__content">
      <div>
          <p v-if="!isSmall"
          :class="`card-promotion-small__duration ${item.hideEndDateOnBanner ? 'd-hidden' : ''}` ">
                <msg id="common.card.promo.expiration" />
                {{ item.duration }}
          </p>
        <h3 class="card-promotion-small__title">{{ item.title }}</h3>
      </div>
      <i class="icon-plus" aria-hidden="true" v-if="!isSmall"></i>
    </div>
  </component>
</template>

<script>
import PgButton from "../Button/Button.vue";
import PgImage from "../Image/Image.vue";
import {formatDate}      from "../../filters/datetime"

export default {
  name: "CardPromotionGrid",
  components: {
    PgButton,
    PgImage,
  },
  filters: {
    formatDate
  },
  data: () => ({
    isSelect: false,
    isSmall: false
  }),
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    value: {
      type: [String, Array],
      default: "",
    },
    select: {
      type: String,
      default: "",
    },
    size: {
      type: String,
      default: "",
    }
  },
  computed: {
    componentIs() {
      let component = "a";

      if (this.select === "direct") {
        component = "label";
      } else if (this.select === "confirm") {
        component = "button";
      }
      return component;
    },
    classes() {
      let selectClass = "";

      if (
          this.$slots.select !== undefined &&
          (this.value === this.item.uuid || this.value.includes(this.item.uuid))
      ) {
        selectClass = "is-selected";
      } else if (this.$slots.select !== undefined) {
        selectClass = "is-not-selected";
      }

      let sizeClass = "";

      switch (this.size) {
        case "sm":
          sizeClass = "card-promotion-small--sm";
          break;
        case "smh":
          sizeClass = "card-promotion-small--smh";
          break;
        default:
          sizeClass = "card-promotion-small--lg";
          break;
      }

      return [sizeClass, selectClass];
    },
    href() {
      let href = this.$options.filters.mgnlLink(this.item.link, "url");
      if (this.select === "direct" || this.select === "confirm") {
        href = false;
      }
      return href;
    },
    isPromotionInDateRange() {
      return !this.item.isFuture && !this.item.isExpired;
    }
  },
  mounted() {
    this.isSelect = this.select === "direct" || this.select === "confirm";

    this.isSmall = this.size === "sm" || this.size === "smh";
    console.log(this.item);
    this.item && this.item.uuid && this.$eventHub.emit("cardPromotion:active-promo", `id-${this.item.uuid}`);
  }
};
</script>
